import { Dispatch } from 'redux';

import { AuthActionType } from 'app/page/auth/redux/model/auth-action-type';
import { TokenService } from 'app/page/auth/services/token-service';
import { NavigationService, navigationService } from 'app/service/navigation-service';
import { RootState } from 'app/redux/state/root-state';
import { ParamUtils } from 'app/utils/param-utils';
import { AuthResetAction } from 'app/page/auth/redux/model/auth-reset-action';
import { orderResetActionCreator } from 'app/page/orders/redux/orders-action-creators';
import { AuthService } from 'app/page/auth/services/auth-service';

const handleAuthorizationCallbackActionCreator = () => (dispatch: Dispatch, getState: () => RootState) => {
    const {
        auth: { codeVerifier, stateParam },
    } = getState();
    const responseState: string | null = ParamUtils.getQueryParam('state');
    const code: string | null = ParamUtils.getQueryParam('code');

    if (responseState !== stateParam) {
        dispatch({
            type: AuthActionType.AUTHORIZE_CALLBACK_FAILURE,
            reason: `Authorization response state ${responseState} doesn't match request state ${stateParam}`,
        });
        return;
    }

    if (!code) {
        dispatch({
            type: AuthActionType.AUTHORIZE_CALLBACK_FAILURE,
            reason: 'Authorization response is missing code parameter',
        });
        return;
    }

    if (!codeVerifier) {
        dispatch({
            type: AuthActionType.AUTHORIZE_CALLBACK_FAILURE,
            reason: 'Code verifier must be present',
        });
        return;
    }

    TokenService.getAccessToken(code, codeVerifier)
        .then((authToken) => {
            dispatch({
                type: AuthActionType.AUTHORIZE_CALLBACK_SUCCESS,
                authToken,
            });
            navigationService.goToPath(NavigationService.CHOOSE_ACCOUNT);
        })
        .catch((error) => {
            dispatch({
                type: AuthActionType.AUTHORIZE_CALLBACK_FAILURE,
                reason: `Failed to fetch access token: ${error.toString()}`,
            });
        });
};

const authResetActionCreator =
    () =>
    (dispatch: Dispatch): void => {
        const authResetAction: AuthResetAction = {
            type: AuthActionType.AUTHORIZE_RESET,
        };

        dispatch(authResetAction);
    };

const logoutActionCreator =
    () =>
    (dispatch: Dispatch): void => {
        navigationService.goToPath(NavigationService.LOGOUT);
        AuthService.logout()
            // eslint-disable-next-line no-console
            .catch(() => console.warn('Failed to logout'))
            .finally(() => {
                authResetActionCreator()(dispatch);
                orderResetActionCreator()(dispatch);
                navigationService.goToHomePage();
            });
    };

export { handleAuthorizationCallbackActionCreator, authResetActionCreator, logoutActionCreator };
